import React from "react";
import { Square2Style } from "./css/Square2Style";
import OutroLogo from "../../components/editor/Templates/OutroLogo";
import OutroText from "../../components/editor/Templates/OutroText";

const square_2 = (props) => {
  return (
    <Square2Style>
      <div className="poster flex-column">
        <div className="logo-container flex-column">
          <OutroLogo logo={props.file} />
        </div>
        <div className="text-wrapper flex-column">
          <OutroText
            id={props.id}
            text={props.text}
            textStyle={props.textStyle}
            editStatus={props.editStatus}
            onInputSlideText={props.onInputSlideText}
          />
        </div>
      </div>
    </Square2Style>
  );
};

export default square_2;
